<script setup>
defineProps({
	isLoading: Boolean
})
</script>

<template>
	<div v-show="isLoading" class="fixed inset-0 z-[9999] flex items-center justify-center bg-black/40 backdrop-blur-sm"
		aria-live="polite" aria-busy="true" role="status">
		<div class="flex flex-col items-center gap-3">
			<span class="h-10 w-10 animate-spin rounded-full border-4 border-white/40 border-t-white"></span>
			<span class="text-white text-sm">Loading…</span>
		</div>
	</div>
	<!-- sentinel to keep component mounted -->
	<span class="hidden" aria-hidden="true"></span>
</template>

<style scoped></style>
